<h5 nz-typography style="margin-top: 25px;">Upload Content Template</h5>




<form nz-form [formGroup]="validForm" >

    <nz-form-item nz-row>
        <nz-form-label nz-col [nzSpan]="4" nzLabelAlign="left" nzRequired nzFor="messageEncoding">File Type</nz-form-label>
        <nz-form-control nz-col [nzSpan]="9"  [nzValidateStatus]="getStatus('messageencoading')!" >
            <nz-radio-group nzButtonStyle="solid" formControlName="messageencoading" [(ngModel)]="messageencoading">
                <label nz-radio-button nzValue="headerfile">Header File</label>
                <label nz-radio-button nzValue="templatefile">Template File</label>


            </nz-radio-group>
        </nz-form-control>
    </nz-form-item>
    

    <nz-form-item nz-row>
        <nz-form-label nz-col [nzSpan]="4" nzLabelAlign="left" nzRequired nzFor="EntityID">Entity ID</nz-form-label>
        <nz-form-control nz-col [nzSpan]="9"  [nzValidateStatus]="getStatus('entityID')!">
            <input nz-input id="campaignName" formControlName="entityID" placeholder="Enter Entity" />
        </nz-form-control>
    </nz-form-item>



    <nz-form-item nz-row>
        <nz-form-label nz-col [nzSpan]="4" nzLabelAlign="left" nzRequired nzFor="text">Template File
            Type</nz-form-label>
        <nz-form-control nz-col [nzSpan]="9" nzErrorTip="Select Sender Id"  [nzValidateStatus]="getStatus('templateType')!">
            <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Select Template File Type" formControlName="templateType" >
                <nz-option nzValue="csv" nzLabel="csv"></nz-option>
                <nz-option nzValue="XLS" nzLabel="XLS" *ngIf="messageencoading=='templatefile'"></nz-option>
            </nz-select>
        </nz-form-control>
    </nz-form-item>

    <nz-form-item nz-row>
        <nz-form-label nz-col [nzSpan]="4" nzLabelAlign="left" nzRequired nzFor="text">Operator</nz-form-label>
        <nz-form-control nz-col [nzSpan]="9" nzErrorTip="Select Sender Id"  [nzValidateStatus]="getStatus('operator')!">
            <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Select Sender Id" formControlName="operator">

            </nz-select>
        </nz-form-control>
    </nz-form-item>

    <nz-form-item nz-row>
        <nz-form-label nz-col [nzSpan]="4" nzLabelAlign="left" nzRequired nzFor="text">File</nz-form-label>
        <nz-form-control nzSpan="9">
            <nz-upload  [nzFileList]="fileList">
                <button nz-button>
                  <span  nz-icon nzType="upload" ></span>
                  Upload
                </button>
              </nz-upload>
        </nz-form-control>
    </nz-form-item>



    <div nz-row [nzJustify]="'center'" [nzGutter]="8" class="margin-top mt">

        <button nz-button nzType="primary" class="btn-gap" (click)="sumbit()" >Submit</button>
        <button nz-button nzType="default" type="button" class="btn-gap">Clear</button>

    </div>


</form>